<template>
    <section>
        <sui-segment basic>
            <sui-button basic icon="reply" floated="left" @click="navigateTo(null, recordName, 'List')">Regresar al listado</sui-button>
            <h2 is="sui-header" floated="right" color="grey">
                <sui-icon name="edit"/>
                <sui-header-content>Detalle de Garantía</sui-header-content>
            </h2>
            <br><br>
        </sui-segment>

        <div class="ui grid">
            <div class="thirteen wide column">
                <!-- DETAIL -->
                <sui-segment class="mt-0">
                    <sui-header dividing class="pb-0 mb-1 mt-0">Datos con conflicto</sui-header>
                    <sui-form v-if="record.rugGuarantee && record.tableBlu === RugTablesBlu.CREDIT">
                        <sui-form-field>
                            <label>Credito</label>
                            <a :href="creditDetailUrl" target="_blank"><span>{{ record.credit.folio }}</span></a>
                        </sui-form-field>
                    </sui-form>
                    <div :style="{ maxWidth: '100%', maxHeight: '300px', overflowY: 'auto' }">
                        <GenericUnPaginatedList v-if="record.rugGuarantee && record.tableBlu === RugTablesBlu.CLIENT"
                            :records="record.rugGuarantee.rugInvoices"
                            :headers="headers"
                        />
                    </div>
                    <sui-header dividing class="pb-0 mb-1 mt-0">Datos de la garantía</sui-header>
                    <sui-form v-if="record.rugGuarantee">
                        <sui-form-fields fields="three">
                            <sui-form-field>
                                <label>Cliente</label>
                                <a :href="clientDetailUrl" target="_blank">
                                    <span>{{ record.client && record.client.entityName ? record.client.entityName : '-' }}</span>
                                </a>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Tipo garantía</label>
                                <span>{{ Utils.displayOptionName(RugGuaranteesStatus, record.rugStatus) }}</span>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Estatus</label>
                                <span class="ui header" :class="(Utils.getRugGuaranteeTobluStatusInfo(record.status)).color">{{ (Utils.getRugGuaranteeTobluStatusInfo(record.status)).name }}</span>
                            </sui-form-field>
                        </sui-form-fields>
                        <sui-form-fields fields="three">
                            <sui-form-field>
                                <label>Número de asiento / Cadena unica de datos</label>
                                <span>{{ record.rugGuarantee.operationNumber }}</span>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Numero de garantía</label>
                                <span>{{ record.rugGuarantee.guaranteeNumber }}</span>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Acreedor</label>
                                <span>{{ record.rugGuarantee.rugCreditor.officialName }}</span>
                            </sui-form-field>
                        </sui-form-fields>
                        <sui-form-fields fields="three">
                            <sui-form-field>
                                <label>Fecha Registro</label>
                                <span>{{ record.rugGuarantee.registrationDate | date }}</span>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Vigencia</label>
                                <span>{{ record.rugGuarantee.period }} meses</span>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Tipo de garantía mobiliaria</label>
                                <span>{{ record.rugGuarantee.guaranteeAct.description }}</span>
                            </sui-form-field>
                        </sui-form-fields>
                        <sui-form-fields fields="three">
                            <sui-form-field>
                                <label>Tipo de bien(es) mueble(s) objeto de la garantía mobiliaria</label>
                                <span>{{ guaranteesTypes }}</span>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Cantidad</label>
                                <span>{{ record.rugGuarantee.amount ? record.rugGuarantee.amount : '-' }}</span>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Moneda</label>
                                <span>{{ record.rugGuarantee.currency ? record.rugGuarantee.currency : '-' }}</span>
                            </sui-form-field>
                        </sui-form-fields>
                        <sui-form-fields fields="three">
                            <sui-form-field>
                                <label>Otorgante</label>
                                <span>{{ record.rugGuarantee.grantorName }}</span>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Folio electrónico</label>
                                <span>{{ record.rugGuarantee.electronicFolio }}</span>
                            </sui-form-field>
                            <sui-form-field>
                                <label>Deudores</label>
                                <span>{{ debtors }}</span>
                            </sui-form-field>
                        </sui-form-fields>
                        <sui-form-field>
                            <label>Descripción</label>
                            <div :style="{ maxWidth: '100%', maxHeight: '300px', overflowY: 'auto' }">
                                {{ record.rugGuarantee.description }}
                            </div>
                        </sui-form-field>
                    </sui-form>
                    <div>
                        <div v-show="record.rugGuarantee && canAddComments" style="padding-top: 50px;">
                            <h4 class="ui dividing header blue">
                            <i class="comment outline icon"></i>
                            <div class="content">Añadir comentario</div>
                            </h4>
                            <sui-form>
                                <sui-form-field :class="{'error': commentsErrors}">
                                <label></label>
                                    <textarea v-model="newComment" id="comment" type="text" rows="2" placeholder="Escriba un comentario" class="field-value form-control"></textarea>
                                    <div class="ui pointing red basic label" v-if="commentsErrors">
                                    {{commentsErrors}}
                                    </div>
                                </sui-form-field>
                            </sui-form>
                            <sui-button size="mini"
                                content="Agregar"
                                color="green"
                                @click="addComment()"
                                style="margin-top: 10px;"
                                :class="{'disabled': !newComment}"/>
                        </div>

                        <div v-if="record.rugGuaranteesToBluComments && record.rugGuaranteesToBluComments.length" style="padding-top: 30px;">
                            <sui-comment-group>
                                <h3 is="sui-header" dividing>Comentarios ({{ record.rugGuaranteesToBluComments.length }})</h3>
                                <sui-comment v-for="(comment, indexComment) of record.rugGuaranteesToBluComments" :key="indexComment">
                                <sui-comment-content>
                                    <span is="sui-comment-author" class="ui header blue">{{comment.user.username}}</span>
                                    <sui-comment-metadata>
                                    <div>{{comment.created_at | dateTime}}</div>
                                    </sui-comment-metadata>
                                    <sui-comment-text>{{comment.comment}}</sui-comment-text>
                                </sui-comment-content>
                                </sui-comment>
                            </sui-comment-group>
                        </div>
                    </div>
                </sui-segment>
            </div>
            <div class="three wide column">
                <!-- ACTIONS -->
                <sui-grid>
                    <sui-grid-row>
                        <sui-grid-column textAlign="center">
                            <div class="ui vertical fluid menu">
                                <div class="header header-menu">ACCIONES</div>
                                <div class="link item"
                                    v-if="record.status === RugGuaranteeToBluStatus.PENDING"
                                    @click="classifyInit(RugGuaranteeToBluStatus.IGNORE)">
                                    Aprobar
                                </div>
                                <div class="link item"
                                    v-if="record.status === RugGuaranteeToBluStatus.PENDING"
                                    @click="classifyInit(RugGuaranteeToBluStatus.INCLUDE)">
                                    Rechazar
                                </div>
                                <div class="item" v-if="record.status !== RugGuaranteeToBluStatus.PENDING">
                                    N/A
                                </div>
                            </div>
                        </sui-grid-column>
                    </sui-grid-row>
                </sui-grid>
            </div>
        </div>

        <ClassifyRugGuaranteeToBlu :status="classifyStatus" :showModal="showClassificationModal" :rugGuaranteeToBlu="record" @modalResponse="classifyFinish"/>
    </section>
</template>

<script>
import Mixins from '@/mixins/index.js'
import RugGuaranteeToBluStatus from '@/common/RugGuaranteeToBluStatus'
import RugGuaranteesStatus from '@/common/RugGuaranteesStatus'
import RugTablesBlu from '@/common/RugTablesBlu'
import Vue from 'vue'
import RugService from '@/services/RugService'
import GenericUnPaginatedList from '@/components/Generic/UnpaginatedList'
import ClassifyRugGuaranteeToBlu from '@/components/Modals/ClassifyRugGuaranteeToBlu'
import Utils from '@/common/Utils.js'

export default {
    name: 'RugGuaranteeToBlu',

    components: { ClassifyRugGuaranteeToBlu, GenericUnPaginatedList },

    mixins: [ Mixins ],

    data () {
        return {
            classifyStatus: null,
            showClassificationModal: false,
            apiEndpoint: '/relations',
            recordService: RugService,
            recordName: 'rugGuaranteeToBlu',
            record: {},
            newComment: '',
            RugGuaranteeToBluStatus,
            RugGuaranteesStatus,
            RugTablesBlu,
            headers: [
                { name: 'UUID', value: 'uuid' },
                { name: 'Folio', value: 'folio' },
                { name: 'RFC Receptor', type: 'object', key: 'factoringDocument', value: 'receiverRFC', width: 4 },
                { name: 'RFC Emisor', type: 'object', key: 'factoringDocument', value: 'emitterRFC', width: 4 },
                { name: 'Importe', type: 'object', key: 'factoringDocument', value: 'total', width: 4, cellclass: 'right aligned', align: 'right' }
            ]
        }
    },

    async beforeMount () {
        if (!this.$store.getters.isLoggedIn) window.location.replace('/logout')
    },

    async mounted () {
        await this.loadRecord(this.$route.params.id)
    },

    methods: {
        async classifyFinish (record) {
            if (record.cancel) {
                this.showClassificationModal = false
                return
            }

            const loader = this.$loading.show()
            if (this.errors.length > 0) {
                loader.hide()
                return
            }

            try {
                const type = Utils.displayOptionName(this.RugGuaranteeToBluStatus, this.classifyStatus)

                let motive = 'Empresa clasificada'
                if (record.motive && record.motive.length > 3) {
                    motive = record.motive
                }

                const response = await RugService.classifyRelation({
                    id: this.record.id,
                    status: this.classifyStatus,
                    rugGuaranteeToBluHistory: {
                        type: type,
                        info: motive,
                        createdBy: this.$store.getters.user.userId
                    }
                })
                loader.hide()

                if (response.item) {
                    await this.loadRecord(this.$route.params.id)
                    this.showClassificationModal = false
                } else {
                    loader.hide()
                    this.$swal('Error', 'Error al guardar', 'error')
                    return { status: 'error' }
                }
            } catch (error) {
                console.error(error)
                loader.hide()
                this.$swal('Error', 'Error al guardar', 'error')
                return { status: 'error' }
            }
        },
        classifyInit (status) {
            let permission = null
            switch (status) {
            case RugGuaranteeToBluStatus.INCLUDE:
                permission = 'can_classify_reject_rug_guarantee_to_blu'
                break
            case RugGuaranteeToBluStatus.IGNORE:
                permission = 'can_classify_aprove_rug_guarantee_to_blu'
                break
            }

            if (!permission || !this.userHasPerm(permission)) {
                this.$swal('Error', 'No tienes permiso para realizar la accion', 'error')
                return
            }

            this.classifyStatus = status
            this.showClassificationModal = true
        },
        onCancel () {
            let routeData = this.$router.resolve({ name: this.recordName + 'List' })
            window.open(routeData.href, '_self')
        },
        async addComment () {
            let loader = this.$loading.show()
            if (this.errors.length > 0) {
                loader.hide()
                return
            }

            try {
                if (!this.canAddComments) {
                    this.$swal('Error', 'No tienes permiso para realizar la accion', 'error')
                    return
                }
                this.commentsErrors = ''
                let comment = this.newComment.replace(/^\s+|\s+$/g, '')
                if (comment.length === 0) {
                    Vue.set(this, 'newComment', '')
                    this.commentsErrors = 'Ingresa un comentario válido'
                    return
                }

                comment = {
                    rugGuaranteeToBluId: this.record.id,
                    comment: this.newComment,
                    createdBy: this.$store.getters.user.userId
                }

                const result = await RugService.commentRelation(comment)

                if (result.id) {
                    Vue.set(this.record, 'rugGuaranteesToBluComments', [result, ...this.record.rugGuaranteesToBluComments])
                    Vue.set(this, 'newComment', '')
                    Vue.set(this, 'commentsErrors', '')
                }

                loader.hide()
            } catch (error) {
                console.error(error)
                loader.hide()
                this.$swal('Error', 'Error al agregar el comentario', 'error')
                return { status: 'error' }
            }
        }
    },

    computed: {
        canAddComments () {
            return this.userHasPerm('can_comment_rug_guarantee_to_blu')
        },
        currency () {
            if (!this.record || !this.record.factoringDocuments || !this.record.factoringDocuments.length) return null
            return this.record.factoringDocuments.map(invoice => invoice.currency)[0]
        },
        guaranteesTypes () {
            return this.record ? this.record.rugGuarantee.guaranteesTypes.map(type => type.description).join(', ') : ''
        },
        debtors () {
            return this.record ? this.record.rugGuarantee.rugDebtors.map(debtor => `${debtor.officialName} (${debtor.taxRegime})`).join(', ') : ''
        }
    }
}
</script>

<style scoped>
    .header-menu {
        padding-top:5px;
        padding-bottom:5px;
        background-color: #1C1D1D;
        color: white;
        font-weight: bolder;
    }
    .item {
        margin-bottom: 5px;
    }
    .left-spaced {
        margin-left: 20px;
    }
    .accepted {
      color: green;
    }
    .rejected {
      color: red;
    }
</style>
